module.exports = __webpack_public_path__ + "img/9.aaf05a43.jpg";